import React from 'react'
import ReactMarkdown from 'react-markdown'
import { Typography, Row, Col } from 'antd'
import CalSettings from 'components/data/calSettings.json'
import Button from 'components/shared/button'
import EmbedPopup from './EmbedPopup'

// import PropTypes from 'prop-types'
const { Title, Text } = Typography

const CalculatorHeading = ({ name }) => {
  return (
    <Row className="page-wrapper" style={{ paddingTop: '32px' }}>
      <Col>
        <Button
          size="large"
          style={{
            color: '#40a9ff',
            fontWeight: '600',
            fontSize: '14px',
          }}
          source="calculator-heading"
        >
          {name}
        </Button>
      </Col>
    </Row>
  )
}

export default function ShortDescription({ calculatorData }) {
  const {
    short_description: shortDescription,
    name,
    slug,
  } = calculatorData.attributes
  const { formula } = CalSettings[slug] || {}
  const calTitle = `What is ${name}? Meaning, Formula & Calculator`
  return (
    <>
      <Row className="page-wrapper">
        <Col span={20}>
          <Title level={3}>
            {formula}
            <EmbedPopup
              calculatorData={calculatorData}
              buttonText="Embed"
              style={{ float: 'right' }}
            />
          </Title>
        </Col>
      </Row>
      <Row className="page-wrapper">
        <Col span={20}>
          <Text strong style={{ fontWeight: 'normal' }}>
            Enrich Your Website and Visitors Experience Now! Get the Embed Code
            and Put this FREE User-friendly Calculator Widget on Your Site.
          </Text>
        </Col>
      </Row>
      <CalculatorHeading name={name} />
      <Row className="page-wrapper">
        <Col span={20}>
          <Title level={1}>{calTitle}</Title>
        </Col>
      </Row>
      <Row>
        <Col md={16} xs={24}>
          <ReactMarkdown>{shortDescription}</ReactMarkdown>
        </Col>
      </Row>
    </>
  )
}

// ShortDescription.propTypes = {
//   calculatorData: PropTypes.shape({
//     short_description: PropTypes.string.isRequired,
//     name: PropTypes.string.isRequired,
//     slug: PropTypes.string.isRequired,
//   }).isRequired,
// }

// CalculatorHeading.propTypes = {
//   name: PropTypes.string.isRequired,
// }
